import classNames from "classnames"

import { ThemeLayoutEnum } from "@/models/ITrackingPageOptions"

import ThemeLayoutPreviewBackdrop from "./ThemeLayoutPreviewBackdrop"
import ThemeLayoutPreviewShowcase from "./ThemeLayoutPreviewShowcase"
import type { ThemeLayoutPreviewViewport } from "./themeLayoutPreviewViewport"

export type { ThemeLayoutPreviewViewport } from "./themeLayoutPreviewViewport"

export interface ThemeLayoutRightProps {
  variant: ThemeLayoutEnum
  viewport: ThemeLayoutPreviewViewport
}

/**
 * 右侧预览：同一套 Backdrop / Showcase，通过 viewport 与外层宽度模拟桌面或移动。
 */
const ThemeLayoutRight = ({ variant, viewport }: ThemeLayoutRightProps) => {
  const isMobile = viewport === "mobile"

  return (
    <div
      className={classNames(
        "flex min-h-0 w-full min-w-0 flex-1 flex-col",
        isMobile && "items-center",
      )}
      data-preview-viewport={viewport}
      data-theme-layout-variant={variant}
    >
      <div
        className={classNames(
          "flex min-h-0 w-full min-w-0 flex-1 flex-col bg-white",
          isMobile && "max-w-[360px]",
        )}
      >
        {variant === ThemeLayoutEnum.BACKDROP ? (
          <ThemeLayoutPreviewBackdrop viewport={viewport} />
        ) : (
          <ThemeLayoutPreviewShowcase viewport={viewport} />
        )}
      </div>
    </div>
  )
}

export default ThemeLayoutRight
